import { ModelApiService } from './BaseApiService'

export default class InvoicesApiService extends ModelApiService {
  constructor() {
    super('invoices')
  }

  async getInvoiceByInvoiceNo(invoiceNo) {
    return this.get(`GetInvoice/${invoiceNo}`)
  }

  async getOustandingInvoicesCount() {
    return this.get(`outstanding-invoices-count`)
  }

  async getInvoiceFile(invoiceId) {
    return this.getBlob(`${invoiceId}/file`)
  }
}
